/* requires:
polyfill.js
*/

const categoryArray = {
  'OSHA Training': ['Construction', 'General Industry', 'MSHA Training'],
  'Hazardous Materials': ['HAZWOPER'],
  'Certificate Courses': ['Construction & Heavy Equipment', 'General Safety & Manufacturing', 'Health & Wellness'],
};

const addProductForm = {
  init: function (formId) {
    const modalElement = document.getElementById('addProductModal');
    // Store modal instance on the element itself to prevent recreation
    if (!modalElement.bootstrapModal) {
      modalElement.bootstrapModal = new bootstrap.Modal(modalElement);
    }
    const categorySelect = document.getElementById('select-course-category');
    const courseSelect = document.getElementById('select-course');
    const theForm = document.getElementById(formId);

    let currentCategory;

    // Reset form state on both init and modal show
    const resetFormState = () => {
      if (currentCategory !== undefined) {
        addProductForm.populateProducts(currentCategory, courseSelect);
      } else {
        const existingMessage = courseSelect.nextElementSibling;
        if (existingMessage && existingMessage.classList.contains('text-danger')) {
          existingMessage.remove();
        }
        this.populateCategories(courseSelect, categorySelect);
        courseSelect.disabled = true;
        courseSelect.innerHTML = `<option value="" selected="selected" disabled>Select Course</option>`;
      }
    };

    // Add modal event listener only once
    if (!modalElement.hasResetListener) {
      modalElement.addEventListener('show.bs.modal', resetFormState);
      modalElement.hasResetListener = true;
    }

    this.validateOnBlur(theForm);
    this.populateCategories(courseSelect, categorySelect);

    // listening for click on the submit button
    const submitBtn = theForm.querySelector('button[type="submit"]');
    const bulkBox = document.getElementById('bulk-box');

    // remove the event listener so we can add it back when the form is re-rendered
    const handleSubmit = (event) => {
      event.preventDefault();
      const isFormValid = addProductForm.isFormValid(theForm);
      if (!isFormValid) {
        alert('Please select your category and course.');
      } else {
        bulkBox.classList.add('processing');
        // Ensure we're using the stored modal instance
        modalElement.bootstrapModal.hide();
        // Get the data-id attribute value of the selected option
        const selectedCourseID = courseSelect.options[courseSelect.selectedIndex].getAttribute('value');
        currentCategory = categorySelect.value;
        cart.addToCart({ productId: selectedCourseID, quantity: 1 }, false, false, () => {
          bulkOrder.init();
          // Get fresh data after cart update
          addProductForm.populateProducts(currentCategory, courseSelect);
          const waitForProcessing = setInterval(() => {
            if (!bulkBox.classList.contains('processing')) {
              clearInterval(waitForProcessing);
              const quantityInput = document.querySelector(`input[name="${selectedCourseID}"]`);
              quantityInput.focus();
            }
          }, 100);
        });
      }
    };
    if (!submitBtn.handleSubmit) {
      submitBtn.handleSubmit = handleSubmit;
      submitBtn.addEventListener('click', submitBtn.handleSubmit);
    }
  },

  populateCategories: function (courseSelect, categorySelect) {
    let categoryOptions = `<option value="" selected="selected" disabled="disabled">Select Category</option>`;

    // For each main category (key) in categoryArray
    for (let mainCategory of Object.keys(categoryArray)) {
      categoryOptions += `<optgroup label="${mainCategory}">`;
      // For each subcategory in the array
      for (let subCategory of categoryArray[mainCategory]) {
        categoryOptions += `<option value="${subCategory}">${subCategory}</option>`;
      }
      categoryOptions += `</optgroup>`;
    }

    categorySelect.innerHTML = categoryOptions;

    categorySelect.addEventListener('change', function () {
      courseSelect.disabled = false;
      addProductForm.populateProducts(this.value, courseSelect);
    });
  },

  populateProducts: function (selectedCategory, courseSelect) {
    const storedProducts = sessionStorage.getItem('productsData');
    const localCart = cart.getLocalCart();
    const localCartProducts = localCart.cartProducts;

    let courseOptions = `<option value="" selected="selected" disabled="disabled">Select Course</option>;`;

    if (storedProducts) {
      const parsedProducts = JSON.parse(storedProducts);
      const courses = parsedProducts
        .filter((product) => product.tags.includes(selectedCategory) && !product.tags.includes('MK-HideOnBulkPage'))
        .sort((a, b) => {
          return a.name.localeCompare(b.name, undefined, {
            numeric: true,
            sensitivity: 'base',
          });
        });

      const createOptionElements = (products, localCartProducts) => {
        return products
          .map((product) => {
            const isInCart = localCartProducts.some((localProduct) => localProduct.productId === product.id);
            return `<option value="${product.id}" ${isInCart ? 'disabled' : ''}>${product.name}${
              isInCart ? ' (In Cart)' : ''
            }</option>`;
          })
          .join('');
      };

      const areAllProductsInCart = (products, localCartProducts) => {
        return products.every((product) => localCartProducts.some((cartProduct) => cartProduct.productId === product.id));
      };

      courseOptions += createOptionElements(courses, localCartProducts);

      // Remove any existing messages
      const existingMessage = courseSelect.nextElementSibling;
      if (existingMessage && existingMessage.classList.contains('text-danger')) {
        existingMessage.remove();
      }

      // Add messages if all products are in cart
      const allCoursesInCart = areAllProductsInCart(courses, localCartProducts);
      if (allCoursesInCart) {
        courseSelect.insertAdjacentHTML(
          'afterend',
          '<div class="text-danger mt-2 small text-center">All courses for this category are already in the cart. Please select a different category.</div>'
        );
      }
    }

    courseSelect.innerHTML = courseOptions;
  },

  validateOnBlur: function (theForm) {
    if (!theForm) return false;

    // realtime form fields validation using blur event
    const fields = theForm.querySelectorAll('.required');
    for (let field of fields) {
      field.addEventListener(
        'blur',
        function (e) {
          const x = field.value;
          if (!x || x.trim() == '') {
            field.classList.add('is-invalid');
          } else {
            field.classList.remove('is-invalid');
          }
        },
        true
      );
    }
  },

  isFormValid: function (theForm) {
    if (!theForm) return false;

    // form fields validation during submission
    const fields = theForm.querySelectorAll('.required');
    let isFormValid = true;
    for (let field of fields) {
      const x = field.value;
      if (!x || x.trim() == '') {
        field.classList.add('is-invalid');
        isFormValid = false;
      } else {
        field.classList.remove('is-invalid');
      }
    }
    return isFormValid;
  },
};

addProductForm.init('add-product-form');
